export type PaymentMethod = 'dealer' | 'motorplan';

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
    dealer: 'Paid to the dealer',
    motorplan: 'Paid to MotorPlan',
};

const METHODS: readonly PaymentMethod[] = ['dealer', 'motorplan'];

export function paymentMethods(): readonly PaymentMethod[] {
    return METHODS;
}
